import { FiltersDialogComponent } from 'src/app/components/filters/filters-dialog.component';
import { filterPageTypes } from './../../store/filters.era';
import { Component } from '@angular/core';
import { FilterDialogComponentParams } from 'src/app/components/filters/filters-ui.models';
import { filterPrograms } from 'src/app/store/reselectors/filteredPrograms.reselector';
import { prepareAndGetTimelineData } from './program.helpers';
import { programsArray } from 'src/app/store/reselectors/programs.reselector';
import { PAGE_NAME } from 'src/app/services/event.permissions.service';
import { timelineParents } from '../../helpers/helpers';
import { Program, ProgramTimelineData } from 'globals/store/programs.data';
import { JoiEvent } from 'src/app/store/events.era';
import { Wrapper } from 'src/app/components/wrapper.component';
import { ZoomWrapper } from 'src/app/components/wrappers/zoom-wrapper.component';
import { CommonModule } from '@angular/common';
import { MobileMenuComponent } from 'src/app/components/menu/mobile-menu.component';
import { TopMenuComponent } from './top.menu';
import { LoaderPaneFragmentComponent } from 'src/app/components/loader/loader-pane-fragment.component';
import { traceNames } from 'src/app/services/performance.tracking.data';
import { TimelineComponent } from 'src/app/components/timeline/timeline.component';

@Component({
    selector: 'program-timeline',
    template: `
<loader-pane-fragment [trace]="traceNames.viewProgramTimeline" [stopOptions]="{attributes:[{name:'NumberOfFilters', value:filtersCount}]}"></loader-pane-fragment>
<top-menu [showFilter]="true" [showPrint]="true" [showZoom]="true" (filter)="filter()" [filtered]="!!actualFilterCount"></top-menu>
<mobile-menu></mobile-menu>
<zoom-wrapper>
  <div class="no_date" *ngIf="!has_date && is_loaded">Only room/locations with dates will appear in the preview.</div>
  <div class="no_date" *ngIf="has_date && data?.multiple_column && !data.multiple_column.length">No programs or sessions.</div>
  <div *ngIf="!is_loaded">
    <div class="background_text">Timeline content loading...</div>
  </div>
  <event-timeline *ngIf="data?.multiple_column?.length" [data]="data" [parent]="timelineParent" (filter)="filter()"></event-timeline>
</zoom-wrapper>
    `,
    styleUrls: ['../../page.scss', './program.timeline.scss'],
    standalone: true,
    imports: [ZoomWrapper, CommonModule, MobileMenuComponent, TimelineComponent, TopMenuComponent, LoaderPaneFragmentComponent],
})

export class ProgramTimelineComponent extends Wrapper<ProgramTimelineComponent> {

    timelineViews = [];
    detailed_view = true;
    programs: Program[]
    traceNames = traceNames
    is_loaded;
    has_date;
    data: ProgramTimelineData
    mobile_date_index = 0;
    actualFilterCount: number
    page_name = PAGE_NAME.program_timeline
    timelineParent = timelineParents.program
    filtersCount = 0
    event: JoiEvent

    constructor() {
      super()
      this.subProp(this.store.select('filters', filterPageTypes.programTimeline, 'count'), 'actualFilterCount')
      this.subProp(this.store.select('events', 'event'), 'event')
      this.subProp(this.store.select('programs','has_date'), 'has_date')
      this.subProp(this.store.select(programsArray), 'programs')
      this.subCallback(this.store.select('programs','loaded'), loaded => {
        this.is_loaded = loaded
        if(!loaded) return;
        this.setTimelineData(true)
      })
      this.uiService.changePageTitle("Event Preview",true)
    }

    async setTimelineData(showSnapshot: boolean) {
      const filters = await this.take1(this.store.select('filters', filterPageTypes.programTimeline))
      this.filtersCount = filters.count
      const filteredPrograms = filterPrograms(this.programs, filters)
      const data = prepareAndGetTimelineData(filteredPrograms, this.timelineViews, this.event)
      this.data = { ...data, title: 'placeholder', showSnapshot }
    }

    async filter() {
      const filterGroupings = await this.filtersService.buildProgramTimelineFilterUI(this.programService.programs)
      const params: FilterDialogComponentParams = { width: '770px', autoFocus: false, data: { filterPage: filterPageTypes.programTimeline, filterGroupings }}
      await this.openDialogGetResult(FiltersDialogComponent, params);
      this.setTimelineData(true)
    }

}

